import Vue from 'vue';
import Router from 'vue-router';

const home = resolve => require(['@/page/web/home'], resolve);
const register = resolve => require(['@/page/web/register'], resolve);
const login = resolve => require(['@/page/web/login'], resolve);
const forget = resolve => require(['@/page/web/forget'], resolve);
const serviceCenter = resolve => require(['@/page/web/serviceCenter'], resolve);
const questionCenter = resolve => require(['@/page/web/questionCenter'], resolve);
const activityCenter = resolve => require(['@/page/web/activityCenter'], resolve);
const activityDetail = resolve => require(['@/page/web/activityDetail'], resolve);
const newsCenter = resolve => require(['@/page/web/newsCenter'], resolve);
const newsDetail = resolve => require(['@/page/web/newsDetail'], resolve);
const organzation = resolve => require(['@/page/web/organzation'], resolve);
const groupDetail = resolve => require(['@/page/web/groupDetail'], resolve);
const about = resolve => require(['@/page/web/about'], resolve);
const aboutDetail = resolve => require(['@/page/web/aboutDetail'], resolve);
const tipsCenter = resolve => require(['@/page/web/tipsCenter'], resolve);
const tipsDetail = resolve => require(['@/page/web/tipsDetail'], resolve);
const serviceDetail = resolve => require(['@/page/web/serviceDetail'], resolve);
const myMessage = resolve => require(['@/page/myBank/myMessage'], resolve);
const fortuneBag = resolve => require(['@/page/myBank/fortuneBag'], resolve);
const fortuneSend = resolve => require(['@/page/myBank/fortuneSend'], resolve);
const fortuneIn = resolve => require(['@/page/myBank/fortuneIn'], resolve);
const myMember = resolve => require(['@/page/myBank/myMember'], resolve);
const myOrganzation = resolve => require(['@/page/myBank/myOrganzation'], resolve);
const changePassword = resolve => require(['@/page/myBank/changePassword'], resolve);
const myPublish = resolve => require(['@/page/myBank/myPublish'], resolve);
const myReceive = resolve => require(['@/page/myBank/myReceive'], resolve);
const myActivity = resolve => require(['@/page/myBank/myActivity'], resolve);
const publishAdd = resolve => require(['@/page/myBank/publishAdd'], resolve);
const serviceAddress = resolve => require(['@/page/myBank/serviceAddress'], resolve);
const addressAdd = resolve => require(['@/page/myBank/addressAdd'], resolve);
const communityEdit = resolve => require(['@/page/myBank/communityEdit'], resolve);
const serviceTime = resolve => require(['@/page/myBank/serviceTime'], resolve);
const serviceAdd = resolve => require(['@/page/myBank/serviceAdd'], resolve);
const applyPeople = resolve => require(['@/page/myBank/applyPeople'], resolve);
const memberDetail = resolve => require(['@/page/myBank/memberDetail'], resolve);
const checkPeople = resolve => require(['@/page/myBank/checkPeople'], resolve);
const feedBack = resolve => require(['@/page/myBank/feedBack'], resolve);
const feedBackAdd = resolve => require(['@/page/myBank/feedBackAdd'], resolve);
const invitePeople = resolve => require(['@/page/myBank/invitePeople'], resolve);
const myActivityMember = resolve => require(['@/page/myBank/myActivityMember'], resolve);
const introduce = resolve => require(['@/page/web/introduce'], resolve);
const organzationDetail = resolve => require(['@/page/web/organzationDetail'], resolve);
const mySingnalList = resolve => require(['@/page/myBank/mySingnalList'], resolve);

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: '/web/',
  routes: [{
    path: '/',
    name: 'home',
    component: home
  },{
    path: '/register',
    name: 'register',
    component: register
  },{
    path: '/serviceCenter',
    name: 'serviceCenter',
    component: serviceCenter
  },{
    path: '/activityCenter',
    name: 'activityCenter',
    component: activityCenter
  },{
    path: '/about',
    name: 'about',
    component: about
  },{
    path: '/aboutDetail',
    name: 'aboutDetail',
    component: aboutDetail
  },{
    path: '/serviceDetail',
    name: 'serviceDetail',
    component: serviceDetail
  },{
    path: '/login',
    name: 'login',
    component: login
  },{
    path: '/myMessage',
    name: 'myMessage',
    component: myMessage
  },{
    path: '/fortuneBag',
    name: 'fortuneBag',
    component: fortuneBag
  },{
    path: '/fortuneSend',
    name: 'fortuneSend',
    component: fortuneSend
  },{
    path: '/fortuneIn',
    name: 'fortuneIn',
    component: fortuneIn
  },{
    path: '/myMember',
    name: 'myMember',
    component: myMember
  },{
    path: '/myOrganzation',
    name: 'myOrganzation',
    component: myOrganzation
  },{
    path: '/changePassword',
    name: 'changePassword',
    component: changePassword
  },{
    path: '/myPublish',
    name: 'myPublish',
    component: myPublish
  },{
    path: '/myReceive',
    name: 'myReceive',
    component: myReceive
  },{
    path: '/myActivity',
    name: 'myActivity',
    component: myActivity
  },{
    path: '/forget',
    name: 'forget',
    component: forget
  },{
    path: '/publishAdd',
    name: 'publishAdd',
    component: publishAdd
  },{
    path: '/newsCenter',
    name: 'newsCenter',
    component: newsCenter
  },{
    path: '/newsDetail',
    name: 'newsDetail',
    component: newsDetail
  },{
    path: '/organzation',
    name: 'organzation',
    component: organzation
  },{
    path: '/tipsCenter',
    name: 'tipsCenter',
    component: tipsCenter
  },{
    path: '/tipsDetail',
    name: 'tipsDetail',
    component: tipsDetail
  },{
    path: '/serviceAddress',
    name: 'serviceAddress',
    component: serviceAddress
  },{
    path: '/addressAdd',
    name: 'addressAdd',
    component: addressAdd
  },{
    path: '/communityEdit',
    name: 'communityEdit',
    component: communityEdit
  },{
    path: '/serviceTime',
    name: 'serviceTime',
    component: serviceTime
  },{
    path: '/serviceAdd',
    name: 'serviceAdd',
    component: serviceAdd
  },{
    path: '/applyPeople',
    name: 'applyPeople',
    component: applyPeople
  },{
    path: '/memberDetail',
    name: 'memberDetail',
    component: memberDetail
  },{
    path: '/activityDetail',
    name: 'activityDetail',
    component: activityDetail
  },{
    path: '/checkPeople',
    name: 'checkPeople',
    component: checkPeople
  },{
    path: '/feedBack',
    name: 'feedBack',
    component: feedBack
  },{
    path: '/feedBackAdd',
    name: 'feedBackAdd',
    component: feedBackAdd
  },{
    path: '/groupDetail',
    name: 'groupDetail',
    component: groupDetail
  },{
    path: '/invitePeople',
    name: 'invitePeople',
    component: invitePeople
  },{
    path: '/myActivityMember',
    name: 'myActivityMember',
    component: myActivityMember
  },{
    path: '/introduce',
    name: 'introduce',
    component: introduce
  },{
    path: '/questionCenter',
    name: 'questionCenter',
    component: questionCenter
  },{
    path: '/organzationDetail',
    name: 'organzationDetail',
    component: organzationDetail
  },{
    path: '/mySingnalList',
    name: 'mySingnalList',
    component: mySingnalList
  }]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js